const initGallery = () => {
  const modal = document.getElementById("gallery-modal");
  if (!modal) return;
  if (modal.dataset.galleryBound === "true") return;
  modal.dataset.galleryBound = "true";

  const image = modal.querySelector(".gallery-modal__image");
  const video = modal.querySelector(".gallery-modal__video");
  const caption = modal.querySelector("[data-gallery-caption]");
  const figure = modal.querySelector(".gallery-modal__figure");
  const closeTriggers = modal.querySelectorAll("[data-gallery-close]");
  const cards = document.querySelectorAll(".gallery-card[data-gallery-full]");
  const prevButton = modal.querySelector("[data-gallery-prev]");
  const nextButton = modal.querySelector("[data-gallery-next]");
  const items = [];
  let currentIndex = -1;
  const urlParam = "photo";
  const accessibilityModeClass = "accessibility-mode";

  const isAccessibilityModeEnabled = () => {
    return Boolean(
      (document.body && document.body.classList.contains(accessibilityModeClass)) ||
        document.documentElement.classList.contains(accessibilityModeClass)
    );
  };

  cards.forEach((card, index) => {
    items.push({
      kind: card.getAttribute("data-gallery-kind") || "image",
      src: card.getAttribute("data-gallery-full"),
      alt: card.getAttribute("data-gallery-alt") || "",
      caption: card.getAttribute("data-gallery-caption") || "",
      id: card.getAttribute("data-gallery-id") || "",
    });
    card.dataset.galleryRuntimeIndex = String(index);
  });

  const updateUrl = (id) => {
    const url = new URL(window.location.href);
    if (id) {
      url.searchParams.set(urlParam, id);
    } else {
      url.searchParams.delete(urlParam);
    }
    history.replaceState(null, "", url);
  };

  const clearVideo = () => {
    if (!video) return;
    video.pause();
    video.removeAttribute("src");
    video.load();
  };

  const openModal = (item, index, text) => {
    if (!item || !image || !video) return;

    if (item.kind === "video") {
      image.src = "";
      image.alt = "";
      image.hidden = true;
      video.hidden = false;
      video.src = item.src;
      video.setAttribute("aria-label", item.alt || "Видео галереи");
      video.load();
    } else {
      clearVideo();
      video.hidden = true;
      image.hidden = false;
      image.src = item.src;
      image.alt = item.alt || "";
    }

    if (caption) {
      const normalized = (text || "").trim();
      caption.textContent = normalized;
      caption.hidden = normalized.length === 0;
      if (figure) {
        figure.classList.toggle("gallery-modal__figure--with-caption", normalized.length > 0);
      }
    }
    currentIndex = Number.isInteger(index) ? index : -1;
    if (currentIndex !== -1 && items[currentIndex] && items[currentIndex].id) {
      updateUrl(items[currentIndex].id);
    }
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("gallery-modal-open");
  };

  const showAt = (index) => {
    if (items.length === 0) return;
    const safeIndex = (index + items.length) % items.length;
    const item = items[safeIndex];
    if (!item || !item.src) return;
    openModal(item, safeIndex, item.caption);
  };

  const closeModal = () => {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    clearVideo();
    if (video) {
      video.hidden = true;
      video.removeAttribute("aria-label");
    }
    image.hidden = false;
    image.src = "";
    image.alt = "";
    if (caption) {
      caption.textContent = "";
      caption.hidden = true;
    }
    if (figure) {
      figure.classList.remove("gallery-modal__figure--with-caption");
    }
    updateUrl(null);
    document.body.classList.remove("gallery-modal-open");
  };

  cards.forEach((card) => {
    card.addEventListener("click", () => {
      const index = Number.parseInt(card.dataset.galleryRuntimeIndex || "-1", 10);
      if (!Number.isNaN(index) && items[index]) {
        if (
          isAccessibilityModeEnabled() &&
          items[index].kind === "image" &&
          items[index].src
        ) {
          window.location.assign(items[index].src);
          return;
        }

        openModal(items[index], index, items[index].caption);
      }
    });
  });

  const openFromUrl = () => {
    const id = new URLSearchParams(window.location.search).get(urlParam);
    if (!id) return;
    const matchIndex = items.findIndex((item) => String(item.id) === String(id));
    if (matchIndex !== -1) showAt(matchIndex);
  };

  window.addEventListener("popstate", () => {
    const id = new URLSearchParams(window.location.search).get(urlParam);
    if (!id) {
      if (modal.classList.contains("is-open")) closeModal();
      return;
    }
    const matchIndex = items.findIndex((item) => String(item.id) === String(id));
    if (matchIndex !== -1) showAt(matchIndex);
  });

  openFromUrl();
  if (prevButton) {
    prevButton.addEventListener("click", () => {
      if (currentIndex === -1) return;
      showAt(currentIndex - 1);
    });
  }

  if (nextButton) {
    nextButton.addEventListener("click", () => {
      if (currentIndex === -1) return;
      showAt(currentIndex + 1);
    });
  }

  closeTriggers.forEach((trigger) => {
    trigger.addEventListener("click", closeModal);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && modal.classList.contains("is-open")) {
      closeModal();
    }
    if (event.key === "ArrowLeft" && modal.classList.contains("is-open")) {
      if (currentIndex !== -1) showAt(currentIndex - 1);
    }
    if (event.key === "ArrowRight" && modal.classList.contains("is-open")) {
      if (currentIndex !== -1) showAt(currentIndex + 1);
    }
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initGallery);
} else {
  initGallery();
}

document.addEventListener("turbo:load", initGallery);
